module.exports = __webpack_public_path__ + "img/compare-form.9e22999.webp";